import { render, staticRenderFns } from "./SchoolOrgList.vue?vue&type=template&id=a7211924&scoped=true"
import script from "./SchoolOrgList.vue?vue&type=script&lang=js"
export * from "./SchoolOrgList.vue?vue&type=script&lang=js"
import style0 from "./SchoolOrgList.vue?vue&type=style&index=0&id=a7211924&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7211924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7211924')) {
      api.createRecord('a7211924', component.options)
    } else {
      api.reload('a7211924', component.options)
    }
    module.hot.accept("./SchoolOrgList.vue?vue&type=template&id=a7211924&scoped=true", function () {
      api.rerender('a7211924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolOrg/SchoolOrgList.vue"
export default component.exports